'use strict';

function KeyboardSaveDirective() {
  return {
    restrict: 'EA',
    scope: true,
    controller: 'KeyboardSaveController'
  };
}
KeyboardSaveDirective.$inject = [];
module.exports = KeyboardSaveDirective;